module.exports = __webpack_public_path__ + "static/media/BG_67.b9d3f742.png";